import React from 'react'
import Game from './Game'
import { initErrorMonitoring, render } from '@educaplay/core'
import { getConfig } from '@educaplay/core'
import { initialize } from '@educaplay/store'
import { RESPONSES } from "./utils/constants"
import { assetsUrl, CONTENT_TYPE, GameProvider } from '@educaplay/core'
import { createCustomization } from '@educaplay/core/utils/customization'

initErrorMonitoring("https://af0c0fff504710a71b6e418ec050ff74@o4509038211104768.ingest.de.sentry.io/4510305640579152");

const YESORNO_SOUNDS = {
  'yesorno-drag': assetsUrl('YESORNO/arrastrar.mp3'),
  'yesorno-correct': assetsUrl('YESORNO/bienactivo.mp3'),
  'yesorno-put': assetsUrl('YESORNO/colocar.mp3'),
  'yesorno-scale': assetsUrl('YESORNO/escalar.mp3'),
  'yesorno-move': assetsUrl('YESORNO/mover.mp3'),
}

const gameImage = assetsUrl("YESORNO/logoActivity.png");

const container = document.getElementById('root')


async function init() {
  const { data, texts, settings, user, title, description, author, id, url } = await getConfig().catch((err) =>
    console.error('Error al obtener la configuración: ', err)
  )

  const { resources } = settings
  const filteredQuestions = data.PREGUNTAS
    .map((question, index) => ({ ...question, id: index }))
    .filter((question) => (question.ENUNCIADO || question.MULTIMEDIA_TIPO))

  const hasBank = filteredQuestions.some((question) => {
    return question.ENUNCIADO_OPCIONAL_MOSTRAR && question.ENUNCIADO_OPCIONAL !== ""
  })

  const questionTimeNumber = Number(data.TIEMPO)
  const questionTime = Number.isNaN(questionTimeNumber) ? 0 : questionTimeNumber

  const questions = filteredQuestions.map(question => {
    const [isCorrectNo, isCorrectYes] = question.RESPUESTAS.map((answer) => answer.RESPUESTA_CORRECTA === "si")
    const correctAnswers = []

    if (isCorrectNo) correctAnswers.push(RESPONSES.NO)
    if (isCorrectYes) correctAnswers.push(RESPONSES.YES)

    return {
      text: question.ENUNCIADO,
      bank: question.ENUNCIADO_OPCIONAL_MOSTRAR ? {
        text: question.ENUNCIADO_OPCIONAL.trim(),
        source: null,
        type: CONTENT_TYPE.TEXT
      } : null,
      checkAnswer: (answer) => correctAnswers.includes(answer),
      answer: null,
      ...(question.MULTIMEDIA_TIPO && {
        media: {
          type: question.MULTIMEDIA_TIPO,
          src: `${resources}${question.MULTIMEDIA}`,
        },
      }),
      correctAnswers: correctAnswers.map((answer) => texts.specific[answer]),
      points: 100 / filteredQuestions.length,
      time: questionTime, // ?? en la ruleta cada palabra se guarda su tiempo
      id: question.id,
    }
  })


  initialize({
    lives: data.NUMERO_INTENTOS,
    liveActived: data.NUMERO_INTENTOS_INFINITOS !== "si",
    hasCountDown: data.TIEMPO_INFINITO === "no",
    randomized: data.ALEATORIO === "si",
    showSolutions: data.OCULTAR_RESPUESTAS !== '1',
    showRestart: data.OCULTAR_REINICIAR !== '1',
    showSocialMedia: data.OCULTAR_REDES !== '1',
    finalText: data.TEXTO_FINAL,
    hasBank,
    questions,
    settings,
    title,
    description,
    author,
    id,
    url,
    user,
    customizations: createCustomization(data)
  })

  render(container, (
    <React.StrictMode>
      <GameProvider
        gameImage={gameImage}
        texts={texts}
        Game={Game}
        sounds={YESORNO_SOUNDS}
        mappers={{
          report: (question) => {
            const isCorrect = question.answer === '' ? false : question.answer && question.checkAnswer(question.answer)
            const formatAnswer = (answer) => {
              if (answer === RESPONSES.YES) return true
              if (answer === RESPONSES.NO) return false
              return answer
            }

            return {
              s: isCorrect,
              i: question.id,
              a: formatAnswer(question.answer)
            }
          }
        }}
        renders={{
          infoLeft: (currentIndex, questions) => {
            return `${texts.specific.sliceType}: ${Math.min(currentIndex + 1, questions.length)} / ${questions.length}`
          }
        }}
      />
    </React.StrictMode>
  ))
}

init()